/**
 * Smooth Header Blend Mode Transition
 * Two-stage transitions for both desktop hover AND mobile scroll
 */

(function() {
  'use strict';

  // ========== DESKTOP HOVER CONFIGURATION ==========
  const HOVER_DELAY = 0;           // Instant on mouseenter
  const BG_FADE_DURATION = 150;     // Time for white bg to fade out
  const BLEND_MODE_DELAY = 0;    // Extra delay before switching blend mode back
  
  // ========== MOBILE SCROLL CONFIGURATION ==========
  const SCROLL_BG_FADE = 300;      // Time for white bg to fade out on scroll (increased)
  const SCROLL_BLEND_DELAY = 100;  // Extra delay before switching blend mode back on scroll (increased)
  
  let hoverTimeout = null;
  let leaveTimeout = null;
  let blendModeTimeout = null;
  let scrollTransitionTimeout = null;
  let scrollLeavingTimeout = null;

  // ========== DESKTOP HOVER LOGIC ==========
  function initDesktopHover() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    // Only run on desktop
    if (window.innerWidth < 990) return;

    // Mouse enter - add hovering class instantly
    header.addEventListener('mouseenter', function() {
      // Clear any pending timeouts
      if (leaveTimeout) {
        clearTimeout(leaveTimeout);
        leaveTimeout = null;
      }
      if (blendModeTimeout) {
        clearTimeout(blendModeTimeout);
        blendModeTimeout = null;
      }
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }

      // Remove leaving class if present
      header.classList.remove('is-leaving');
      
      // Add hovering class instantly
      hoverTimeout = setTimeout(() => {
        header.classList.add('is-hovering');
      }, HOVER_DELAY);
    });

    // Mouse leave - TWO STAGE process
    header.addEventListener('mouseleave', function() {
      // Clear any pending hover timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }

      // STAGE 1: Add leaving class to start fading out white bg (keeps blend mode normal)
      header.classList.add('is-leaving');
      
      // STAGE 2: After bg has faded, switch blend mode back to difference
      blendModeTimeout = setTimeout(() => {
        header.classList.remove('is-hovering');
        header.classList.remove('is-leaving');
      }, BG_FADE_DURATION + BLEND_MODE_DELAY);
    });
  }

  // ========== MOBILE SCROLL LOGIC ==========
  function initMobileScroll() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    // Only run on mobile
    if (window.innerWidth >= 990) return;

    let wasScrollingUp = false;

    // Watch for class changes on the header (Dawn adds/removes scrolling-up)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isScrollingUp = header.classList.contains('scrolling-up');
          
          // Detect transition from scrolling-up TO scrolling-down
          if (wasScrollingUp && !isScrollingUp) {

            // Clear ALL pending timeouts to prevent stale callbacks
            clearTimeout(scrollTransitionTimeout);
            clearTimeout(scrollLeavingTimeout);

            // STAGE 1: Keep blend mode normal, white bg visible
            header.classList.add('is-scrolling-transition');
            header.classList.remove('is-scrolling-leaving');

            // STAGE 2: Start fading white bg (blend mode still normal)
            scrollLeavingTimeout = setTimeout(() => {
              header.classList.add('is-scrolling-leaving');
            }, SCROLL_BLEND_DELAY);

            // STAGE 3: After bg has faded, NOW switch blend mode
            scrollTransitionTimeout = setTimeout(() => {
              header.classList.remove('is-scrolling-transition');
              header.classList.remove('is-scrolling-leaving');
            }, SCROLL_BLEND_DELAY + SCROLL_BG_FADE);
          }

          // Detect transition from scrolling-down TO scrolling-up
          if (!wasScrollingUp && isScrollingUp) {

            // Clear ALL pending timeouts
            clearTimeout(scrollTransitionTimeout);
            clearTimeout(scrollLeavingTimeout);

            // Remove all transition classes immediately when scrolling up
            header.classList.remove('is-scrolling-transition');
            header.classList.remove('is-scrolling-leaving');
          }
          
          wasScrollingUp = isScrollingUp;
        }
      });
    });

    // Start observing
    observer.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Initialize on DOM ready
  function init() {
    if (window.innerWidth >= 990) {
      initDesktopHover();
    } else {
      initMobileScroll();
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const header = document.querySelector('.section-header');
        if (!header) return;
        
        // Clean up classes when crossing breakpoint
        if (window.innerWidth < 990) {
          header.classList.remove('is-hovering');
          header.classList.remove('is-leaving');
        } else {
          header.classList.remove('is-scrolling-transition');
        }
      }, 250);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinitialize on Shopify section load (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();